<template>
  <div>
    
    <div class="d-flex justify-content-between">
      <h5 class="mt-1">Historial de Imágenes</h5>
      <h6 class="text-right my-1 mx-1">Total: {{table.totalRows}}</h6>
    </div>
    
    <b-table
      v-if="historialImagenes.length"
      id="table-img" 
      responsive bordered  
      small 
      :items="historialImagenes" 
      :fields="fieldsImagenes" 
      :per-page="table.perPage"
      :current-page="table.page"
    >
      <template #cell(fechaProgramada)="data">
        <small>
          {{ data.item.fechaProgramada}}
        </small>
      </template>

      <template #cell(descripcion)="data">
        <small
          :id="'tooltip-target-' + data.index"
          v-b-tooltip.hover
          :title="data.item.descripcion"
        >
          <!-- {{ data.item.descripcion.split(" ").slice(0, 5).join(" ") + "..." }} -->
          {{ data.item.descripcion }}

        </small>
      </template>
                        
      <template #cell(acciones)="data">
        <b-button 
          variant="info" 
          size="sm" 
          style="cursor: pointer; padding: 6px;"
          @click="onViewImagenProgramada(data.item.token)"
        >
          <font-awesome-icon icon="magnifying-glass" style="color: white"/>
        </b-button>
      </template>
    </b-table>

    <div
      v-if="historialImagenes.length && table.totalRows > table.perPage"
      class="d-flex justify-content-center"
    >

      <b-pagination
        v-model="table.page"
        :total-rows="historialImagenes.length"
        :per-page="table.perPage"
        aria-controls="table-img"
      />
    </div>

    <b-skeleton-wrapper v-if="loadingData">
      <b-skeleton 
        v-for="i in 6"
        :key="i"
        width="100%" 
        height="35px"
      />
    </b-skeleton-wrapper>

    <EmptyResults
      size="sm"
      v-if="!historialImagenes.length && !loadingData"
    />

    <VerImagenProgramada/>

  </div>

</template>
  
<script>
import { BootstrapVue }            from 'bootstrap-vue';
import { stringDateToGeneralDate } from '@/shared/helpers';
import { EmptyResults }            from '@/shared/components';
import { VerImagenProgramada }     from '@/views/imagen/components';
import { imagenesService }         from '../../../imagen/services/imagenesService';
  
export default {

  props: {
    idPaciente : String
  },

  components: {
    ...BootstrapVue.components,
    VerImagenProgramada,
    EmptyResults
  },


  created() {
    this.loadDataHistorial();
  },

  data() {
    return {

      table:{
        perPage: 8,
        page: 1,
        totalRows: 0
      },

      historialImagenes : [],
      loadingData: false,
      
      fieldsImagenes: [
        { key: "fechaProgramada", label: "Fecha" },
        { key: "descripcion",     label: "Imagen" },
        // { key: "estado",          label: "estado" },
        
        {
          key: "acciones",
          label: "Ver",
          sortable: true,
          thClass: "text-center",
          tdClass: "text-center",
        },

      ],
    }
  },

  methods : {

    async loadDataHistorial(){

      this.loadingData = true;

      const params = {
        idPaciente : this.idPaciente
      };

      const responseSearch = await imagenesService.getAll(params);

      if(!responseSearch) {
        this.loadingData = false;
        return
      }

      this.table.totalRows = responseSearch.total;
      const mapperImagenes = responseSearch.data.map(item => {

        const fechaProgramada = item.fechaProgramada 
          ? stringDateToGeneralDate(item.fechaProgramada).date
          : 'Sin fecha';

        return {
          id              : item.id,
          token           : item.token,
          fechaProgramada : fechaProgramada,
          descripcion     : item.imagen.nombre,
          estado          : item.estadoImagen,
        }
      })

      this.historialImagenes = mapperImagenes
      this.loadingData = false;
    },

    onViewImagenProgramada(tokenImagen){
     
      try {
        this.$router.push({
          path: this.$route.path,
          query: {
            ...this.$route.query, 
            view_imagen: tokenImagen
          }
        });
      } catch (error) { console.log("este es el rror", error) }
    },

  }

};
</script>
  